export type AppUserRole = "USER" | "CREATOR" | "CURATOR" | "ADMIN";

/** Viewer / end-user home layout (browse, watchlist, etc.). */
export const USER_LAYOUT_ROLES: readonly AppUserRole[] = ["USER"];

/** Creator-style shell (library, uploads); curators share this layout. */
export const CREATOR_LAYOUT_ROLES: readonly AppUserRole[] = [
  "ADMIN",
  "CREATOR",
  "CURATOR",
];

/** Roles allowed into the `/home/*` authenticated shell (outer RoleGuard). */
export const HOME_SHELL_ROLES: readonly AppUserRole[] = [
  "ADMIN",
  "USER",
  "CREATOR",
  "CURATOR",
];

export function normalizeUserRole(
  raw: string | null | undefined
): AppUserRole | null {
  if (!raw) return null;

  const value = raw.trim().toUpperCase();
  if (value === "VIEWER") return "USER";
  if (value === "USER") return "USER";
  if (value === "CREATOR") return "CREATOR";
  if (value === "CURATOR") return "CURATOR";
  if (value === "ADMIN") return "ADMIN";
  return null;
}

export function isUserLayoutRole(role: AppUserRole | null): boolean {
  return role != null && USER_LAYOUT_ROLES.includes(role);
}

export function isCreatorLayoutRole(role: AppUserRole | null): boolean {
  return role != null && CREATOR_LAYOUT_ROLES.includes(role);
}

/** CSS modifier for `main-content` under `Home`. */
export function mainContentClassForRole(role: AppUserRole | null): string {
  if (isCreatorLayoutRole(role)) return "main-content--creator";
  if (isUserLayoutRole(role)) return "main-content--user";
  return "";
}
